// ✅ Naya Backend URL jo aapne screenshot mein dikhaya
const API_BASE_URL = "https://data.lacegota.in/api"; 

// 1. Categories Fetch (CATEGORY FIX)
export const getCategories = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/categories-with-images`);
    if (!response.ok) throw new Error("Network error");
    return await response.json();
  } catch (error) {
    console.error("Category Error:", error);
    return []; 
  }
};

// 2. Image Helper (Iske bina category/product images nahi dikhengi)
export const getImageUrl = (image) => {
  // Keep the fallback local so category cards do not depend on a third-party
  // placeholder service (which can be blocked or unavailable).
  if (!image) return "/placeholder.jpg";
  if (typeof image === "string") return image;
  if (image.src) return image.src; // WooCommerce format
  if (Array.isArray(image) && image.length > 0) return image[0].src || image[0];
  return "/placeholder.jpg";
};

// 3. Razorpay Order (Original Connection Style)
export const createRazorpayOrder = async (amount) => {
  try {
    const response = await fetch(`${API_BASE_URL}/create-razorpay-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: Math.round(amount) }), 
    });
    return await response.json();
  } catch (error) {
    console.error("Razorpay Error:", error);
    return null;
  }
};

// 4. WooCommerce Order (Missing function fix)
export const createOrder = async (orderData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(orderData),
    });
    return await response.json();
  } catch (error) {
    console.error("Order Error:", error);
    return { error: true };
  }
};

// 5. User Registration (Backend ke through)
export const registerUser = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Register API Error:", error);
    return { error: true, message: "Server connection failed" };
  }
};

// 6. User Login (Backend ke through)
export const loginUser = async (credentials) => {
  try {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(credentials),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Login API Error:", error);
    return { error: true, message: "Server connection failed" };
  }
};
